import _ from 'lodash';
import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';
import {
  getAuthenticatedProfileId,
  getSelectedProfileId,
  getEditingProfileId
} from './auth';

import { getRoles } from './roles';

const profileEditorFormSelector = formValueSelector('profileEditor');

const getProfiles = state => state.profile.all;

const getAccountHoldersProfile = createSelector(
  getProfiles,
  profiles => _.find(profiles, profile => profile.accountHolder)
);

const getProfilesById = createSelector(
  getProfiles,
  profiles => _.keyBy(profiles, 'id')
);

const getSelectedProfile = createSelector(
  getSelectedProfileId,
  getProfiles,
  (profileId, profiles) => _.find(profiles, p => p.id === profileId)
);

const getEditingProfile = createSelector(
  getEditingProfileId,
  getProfiles,
  (profileId, profiles) => _.find(profiles, p => p.id === profileId)
);

const getIsDiaryUnlocked = createSelector(
  getAuthenticatedProfileId,
  getSelectedProfileId,
  (authenticatedProfileId, selectedProfileId) =>
    !!authenticatedProfileId && authenticatedProfileId === selectedProfileId
);

const getIsDiarySetup = createSelector(
  getSelectedProfile,
  profile => profile.email !== null && profile.pin !== null
);

const getIsPrimaryProfile = state => state.profile.all.length === 1;

const getProfileSelectedRoleId = state =>
  profileEditorFormSelector(state, 'roleId');

  const getProfileRoleOtherSelected = createSelector(
  getRoles,
  getProfileSelectedRoleId,
  (roles, roleId) => {
    const role = roles.find(theRole => theRole.id === roleId);
    return roleId !== null && role !== undefined && role.other;
  }
);

const getValues = state =>
  profileEditorFormSelector(
    state,
    'firstName',
    'lastName',
    'roleId',
    'roleOther',
    'icon',
    'signUpRequestId'
  );

const getRequiredFields = createSelector(
  getProfileRoleOtherSelected,
  isOtherSelected => {
    const requiredFields = ['firstName', 'lastName', 'roleId', 'icon'];
    if (isOtherSelected) {
      requiredFields.push('roleOther');
    }
    return requiredFields;
  }
);

const getIsProfileEditorButtonDisabled = createSelector(
  getValues,
  getRequiredFields,
  (values, requiredFields) =>
    requiredFields.reduce((isDisabled, fieldName) => {
      const value = values[fieldName];
      return (
        isDisabled || value === null || value === undefined || value === ''
      );
    }, false)
);

const getIsEditingCurrentProfile = state =>
  state.auth.profile === state.auth.editingProfile;

const getProfilesListLoading = state => state.profilesList.loading;

const getProfilesPatchLoading = state => state.profilesPatch.loading;

const getProfilesPostLoading = state => state.profilesPost.loading;

const getProfilesLoading = createSelector(
  getProfilesListLoading,
  getProfilesPatchLoading,
  getProfilesPostLoading,
  (listLoading, patchLoading, postLoading) =>
    listLoading || patchLoading || postLoading
);

export {
  getProfiles,
  getProfilesById,
  getSelectedProfile,
  getEditingProfile,
  getIsDiaryUnlocked,
  getIsDiarySetup,
  getIsPrimaryProfile,
  getProfileRoleOtherSelected,
  getIsProfileEditorButtonDisabled,
  getIsEditingCurrentProfile,
  getAccountHoldersProfile,
  getProfilesLoading
};



// WEBPACK FOOTER //
// ./src/selectors/profiles.js